export default __webpack_public_path__ + "static/media/Img2.d83f2b61.png";